import { Component, OnInit, Input } from '@angular/core';
import { DialogConfig } from '../../dialog/dialog-config';
// import { AlertsService } from 'src/modules/base/services/alerts.service';
// import { BaseService } from 'src/modules/base/shared/services/base.service';
// import { Router } from '@angular/router';
// import { AppService } from 'src/modules/base/shared/services/app.service';
// declare var AceDiff: any;
// declare var jQuery: any;
declare var ace: any;
@Component({
  selector: 'json-viewer',
  styleUrls: ['./json-viewer.component.scss'],
  templateUrl: './json-viewer.component.html',
  standalone: false
})
export class JsonViewerComponent implements OnInit {

  @Input() config: any = {};
  diffRows: any[];
  constructor(
    public dialogConfig: DialogConfig) {
  }

  ngOnInit() {
    if (this.config.data != undefined) {
      this.setUpViewer(this.config.data);
    }
    else if (this.dialogConfig.data != undefined) {
      if (this.dialogConfig.data.diff_check) {
        this.setUpDiffViewer(this.dialogConfig.data);
      }
      else {
        this.setUpViewer(this.dialogConfig.data);
      }
    }
  }

  // sestUpDiffViewer(data: any) {
  //   let oldData: any = {};
  //   let newData: any = {};
  //   Object.keys(data).forEach(key => {
  //     oldData[key] = data[key].old_value ?? '';
  //     newData[key] = data[key].new_value ?? '';
  //   });
  //   delete oldData.diff_check;
  //   delete newData.diff_check;
  //   this.config.diffEditor = new AceDiff({
  //     element: '#jsoneditor',
  //     left: {
  //       content: JSON.stringify(oldData, null, '\t'),
  //       mode: 'ace/mode/json'
  //     },
  //     right: {
  //       content: JSON.stringify(newData, null, '\t'),
  //       mode: 'ace/mode/json'
  //     }
  //   });
  //   let leftEditor = this.config.diffEditor.getEditors().left;
  //   let rightEditor = this.config.diffEditor.getEditors().right;

  //   [leftEditor, rightEditor].forEach((editor: any) => {
  //     editor.setReadOnly(true);
  //     editor.setFontSize(16);
  //     editor.setOption('wrap', 120);

  //   });
  // }


  setUpDiffViewer(data: any): void {
    this.diffRows = [];
    Object.keys(data).forEach(key => {
      if (key === 'diff_check') {
        return;
      }
      const oldValue = this.formatValue(
        data[key]?.old_value,
        key
      );
      const newValue = this.formatValue(
        data[key]?.new_value,
        key
      );

      const oldEmpty = oldValue === '' || oldValue === null || oldValue === undefined;
      const newEmpty = newValue === '' || newValue === null || newValue === undefined;

      let status;
      if (!oldEmpty && newEmpty) {
        status = 'removed';
      }
      else if (oldEmpty && !newEmpty) {
        status = 'added';
      }
      else if (oldValue !== newValue) {
        status = 'updated';
      }
      if (status) {
        this.diffRows.push({
          field: this.convertString(key),
          oldValue,
          newValue,
          status
        });
      }
    });
  }

  convertString(string) {
    let result = string.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    return result
  }

  private formatValue(value: any, key?: string): any {
    if (!value) {
      return '';
    }
    if (key && key.toLowerCase().includes('time') && !isNaN(Number(value))) {
      return new Date(Number(value)).toLocaleString();
    }
    if (Array.isArray(value)) {
      return value
        .map(item => {
          if (typeof item === 'object') {
            return JSON.stringify(item);
          }
          return item;
        })
        .join(', ');
    }
    if (typeof value === 'object') {
      return JSON.stringify(value, null, 2);
    }
    return String(value);
  }

  setUpViewer(data: any) {
    this.config.editor = ace.edit('jsoneditor');
    //for now doing hardcoding if more configuration needed it will be input config based
    this.config.editor.getSession().setMode("ace/mode/json");
    this.config.editor.setReadOnly(true);
    this.config.editor.setFontSize(16);
    this.config.editor.setOption("wrap", 120);
    this.config.editor.setValue(JSON.stringify(data, null, '\t'));
  }

  ngOnDestroy() {
    if (this.config.editor) {
      if (this.config.editor.destroy) {
        this.config.editor.destroy();
      }
      if (this.config.editor.container) {
        this.config.editor.container.remove();
      }
    }
    if (this.config.diffEditor && this.config.diffEditor.destroy) {
      this.config.diffEditor.destroy();
    }
  }
}
